import { render } from "./WYSIWYGEmailEditor.vue?vue&type=template&id=cc64b684&scoped=true&ts=true"
import script from "./WYSIWYGEmailEditor.vue?vue&type=script&lang=ts"
export * from "./WYSIWYGEmailEditor.vue?vue&type=script&lang=ts"

import "./WYSIWYGEmailEditor.vue?vue&type=style&index=0&id=cc64b684&lang=scss&scoped=true"
import "./WYSIWYGEmailEditor.vue?vue&type=style&index=1&id=cc64b684&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc64b684"]])

export default __exports__